import React from "react";
import Card from "../../../components/card";
import InputForm from "../../../components/input-form";
import InputDateTime from "../../../components/input-datetime";
import InputCheckbox from "../../../components/input-checkbox";
import SelectComponent from "../../../components/select-component";
import {MaskDefault} from "../../../utils/mask";
import {useQuery} from "@tanstack/react-query";
import {cvDepartmentService, cvPositionService} from "../../../services/curriculum-resource-service";

const employmentRegimeOptions = [
    {value: "CLT", label: "CLT"},
    {value: "CNPJ", label: "CNPJ"},
];

const ProfessionalSection = ({
    state,
    handleInput,
    handleSelect,
    handleDateInput,
    handleCheckBox,
    disabled,
}) => {
    const {data: departmentOptions = [], isFetching: isFetchingDepartments} = useQuery({
        queryFn: () => cvDepartmentService.options().then(({data}) => (
            data.map(({id, name}) => ({value: id, label: name}))
        )),
        queryKey: ["cv-departments-options"],
    });

    const {data: positionOptions = [], isFetching: isFetchingPositions} = useQuery({
        queryFn: () => cvPositionService.options().then(({data}) => (
            data.map(({id, name}) => ({value: id, label: name}))
        )),
        queryKey: ["cv-positions-options"],
    });

    return (
        <Card title="Dados profissionais">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-4">
                <SelectComponent instanceId="department_id" name="department_id" label="Departamento *"
                                 options={departmentOptions} value={state.department_id}
                                 onChange={(value) => handleSelect("department_id", value)}
                                 isLoading={isFetchingDepartments} isDisabled={disabled} col="col-span-6"/>
                <SelectComponent instanceId="position_id" name="position_id" label="Cargo *"
                                 options={positionOptions} value={state.position_id}
                                 onChange={(value) => handleSelect("position_id", value)}
                                 isLoading={isFetchingPositions} isDisabled={disabled} col="col-span-6"/>

                <InputDateTime id="interview_date" label="Data de entrevista"
                               selected={state.interview_date}
                               onChange={(value) => handleDateInput(value, "interview_date")}
                               col="col-span-4" disabled={disabled}/>
                <InputDateTime id="feedback_date" label="Data de devolutiva"
                               selected={state.feedback_date}
                               onChange={(value) => handleDateInput(value, "feedback_date")}
                               col="col-span-4" disabled={disabled}/>
                <InputDateTime id="evaluation_date" label="Data da avaliação"
                               selected={state.evaluation_date}
                               onChange={(value) => handleDateInput(value, "evaluation_date")}
                               col="col-span-4" disabled={disabled}/>

                <InputForm id="evaluation" name="evaluation" label="Avaliação"
                           col="col-span-6" value={state.evaluation} onChange={handleInput} disabled={disabled}/>
                <SelectComponent instanceId="employment_regime" name="employment_regime"
                                 label="Regime de contratação" options={employmentRegimeOptions}
                                 value={state.employment_regime}
                                 onChange={(value) => handleSelect("employment_regime", value)}
                                 col="col-span-2" isDisabled={disabled}/>
                <InputForm id="referral" name="referral" label="Indicação" value={state.referral}
                           onChange={handleInput} col="col-span-4" disabled={disabled}/>

                <div className={"flex gap-4 col-span-6"}>
                    <InputCheckbox id="employed" label="Está empregado?" checked={state.employed}
                                   onChange={handleCheckBox} col="w-[174px]" disabled={disabled}/>
                    <InputForm id="last_employer" name="last_employer" label="Local do último emprego"
                               col="w-full" value={state.last_employer} onChange={handleInput} disabled={disabled}/>
                </div>
                <InputForm id="last_salary" name="last_salary" label="Último salário"
                           col="col-span-2" value={state.last_salary}
                           onChange={handleInput} mask={MaskDefault.salary} disabled={disabled}/>
                <InputForm id="salary_expectation" name="salary_expectation" label="Pretensão salarial"
                           col="col-span-2" value={state.salary_expectation}
                           onChange={handleInput} mask={MaskDefault.salary} disabled={disabled}/>
                <InputCheckbox id="can_relocate" label="Pode ser realocado?" checked={state.can_relocate}
                               onChange={handleCheckBox} col="col-span-2" disabled={disabled}/>
            </div>
        </Card>
    );
};

export default ProfessionalSection;
